import { render, staticRenderFns } from "./CreateBrand.vue?vue&type=template&id=abc4c012&"
import script from "./CreateBrand.vue?vue&type=script&lang=js&"
export * from "./CreateBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports